/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useStores } from "@/app/csr-src/models";
import { observer } from "mobx-react-lite";
import { debounce } from "lodash";
// import { checkContact } from '@/apis/checkout/service';
import { getPayResult, redirectPayResult, checkContact } from "@/app/csr-src/apis/checkout/checkout.api";
import { PAY_STATUS, RESULT_STR } from "@/app/csr-src/apis/checkout/constants/constants";

import { Button } from "@mui/material";
import UKMaskLoading from "@/common-components-src/components/UKMaskLoading/index";
import Recommend from "@/common-components-src/js/recommend/index";
import TransactionStep from "../../components/transactionStep/index";
import { EmailBindModal } from "./components/emailBindModal";
import AddEmailModal from "./components/addEmailModal";

import SuccessIcon from "@/app/csr-src/assets/icons/SuccessIcon.svg";
import ProcessIcon from "@/app/csr-src/assets/icons/ProcessIcon.svg";

import Styles from "./finish.module.scss";
import { sendPv, sendClickTrack as sendPayClickTrack, sendKeyActionTrack as sendPayKeyActionTrack } from "@/tracks/25322";
import { EXPOSURE_RECORD, sendClickTrack } from "@/tracks/25351";

import type { ICheckContactResp } from "@/app/csr-src/apis/checkout/checkout.interface";

const PayFinish = observer(() => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const query = new URLSearchParams(useLocation().search);
  const { id, payMethod, orderId } = useParams();
  const { orderStore } = useStores();

  const [status, setStatus] = useState<number | null>(null);

  const [content, setContent] = useState<any>({});
  const [payContent, setPayContent] = useState<string>("");
  const [open, setOpen] = useState(false);
  const [showAddEmailModal, setShowAddEmailModal] = useState(false);
  
  const [tipData, setTipData] = useState({
    title: "",
    subTitle: "",
    btn: "",
    subBtn: "",
  });
  const payResultInfo = useRef<any>(null);

  const initData = async () => {
    if (!id || !payMethod || !orderId) {
      orderStore.setOrderType("1");
      toPage("list");
      return;
    }

    redirectResult();
  };
  // 重定向支付结果处理接口
  const redirectResult = async () => {
    const queryObj: any = {};
    for (const [key, value] of query.entries()) {
      queryObj[key] = value;
    }

    const requestData = {
      txnSeqno: id,
      txnScene: "Consumption",
      payMethod: Number(payMethod) || 15,
      urlParams: queryObj,
    };
    UKMaskLoading.show();
    const res = await redirectPayResult({ ...requestData });

    const statusRes = res?.status;
    console.log(res, "statusRes");
    payResultInfo.current = res; // 保存支付结果信息

    if (statusRes) {
      setStatus(statusRes);

      const con = getContent(res || {});
      setContent(con);

      // 支付状态是3，则关闭loading，显示成功
      if (Number(statusRes) === PAY_STATUS.SUCCESS) {
        setPayContent(res.payResultContent || "");
        /** 支付结果成功，添加曝光埋点 */
        showOrderTrack();
        UKMaskLoading.close();
        // need true ***
        checkNeedBind();
        return;
      }
      // 支付状态不是1/2，则轮询查询支付结果
      if (Number(statusRes) !== PAY_STATUS.INIT && Number(statusRes) !== PAY_STATUS.PROCESS) {
        toOrderList();
        return;
      }
    }

    await getIntervalResult(); // 轮询查询支付结果
  };

  /** 支付结果返回，添加曝光埋点 */
  const showOrderTrack = () => {
    sendPayKeyActionTrack.payment_completed_order_details_expo({
      orderId: (payResultInfo as any).current.orderId || "-100",
    });
    sendPayKeyActionTrack.payment_completed_continue_shopping_expo({
      orderId: (payResultInfo as any).current.orderId || "-100",
    });
    sendPayKeyActionTrack.payment_completed_pay_info_floor_expo({
      orderId: (payResultInfo as any).current.orderId || "-100",
      payWay: String(payMethod),
      channelName: (payResultInfo as any).current.payEnum || "-100",
      payResult: (payResultInfo as any).current.status === PAY_STATUS.SUCCESS ? "1" : "0",
    });
  };

  const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
  const getIntervalResult = async () => {
    let retry = 12;
    let result = "";
    while (retry--) {
      result = await getResult();
      if (result === RESULT_STR.SUCCESS) {
        showOrderTrack();
        UKMaskLoading.close();
        // need true ***
        checkNeedBind();
        break;
      }
      if (result === RESULT_STR.ERROR) {
        toOrderList();
        break;
      }
      await sleep(5000);
    }

    console.log(result, "res---");

    if (result !== RESULT_STR.SUCCESS) {
      toOrderList();
      return;
    }
  };

  const getResult = async () => {
    const requestData = {
      txnSeqno: id,
      txnScene: "Consumption",
    };

    const res = await getPayResult({ ...requestData });
    payResultInfo.current = res; // 保存支付结果信息
    const statusRes = res?.status;
    if (statusRes) {
      setStatus(statusRes);

      const con = getContent(res || {});
      setContent(con);

      // 支付状态是3，则关闭loading，显示成功
      if (Number(statusRes) === PAY_STATUS.SUCCESS) {
        setPayContent(res.payResultContent);
        UKMaskLoading.close();
        return RESULT_STR.SUCCESS;
      }

      if (statusRes !== PAY_STATUS.INIT && statusRes !== PAY_STATUS.PROCESS) {
        return RESULT_STR.ERROR;
      }
    }
    return RESULT_STR.CONTINUE;
  };

  const getContent = (params: any) => {
    const { status } = params;

    switch (status) {
      case PAY_STATUS.SUCCESS:
        return {
          tip: t("checkout.finish.success.tip"),
          icon: <SuccessIcon width={"32px"} height={"32px"} />,
          title: t("checkout.finish.success.title"),
        };
      // case PAY_STATUS.ERROR:
      //   return {
      //     tip: failReason,
      //     icon: <WarningIcon width={"32px"} height={"32px"} />,
      //     title: t("checkout.finish.fail.title"),
      //   };
      //   break;

      default:
        return {
          tip: "",
          icon: <ProcessIcon width={"32px"} height={"32px"} />,
          title: t("checkout.finish.processing.title"),
        };
    }
  };

  const toPage = (type: string, actionType: string = "jump") => {
    const map: any = {
      index: "/",
      list: "/profile/my-orders",
    };
    /** 支付失败，跳转定列，添加曝光埋点 */
    if (actionType === "jump") {
      showOrderTrack();
    }
    if (type === "index") {
      window.location.href = "/";
      return;
    }
    navigate(map[type], { replace: true });
  };

  const toOrderList = () => {
    UKMaskLoading.close();
    orderStore.setOrderType("1");
    toPage("list");
  };

  // 检查是否需要绑定邮箱
  const checkNeedBind = () => {
    checkContact({
      pageType: 2, // 支付完成页面
      actionType: 1, // 检查是否需要绑定联系方式
    })
      .then((response: ICheckContactResp) => {
        if (response.success && response.data?.needBind) {
          setTipData(response.data.checkContactTipDTO);
          setOpen(true);
        }
      })
      .catch((error) => {
        console.error("Check contact bind status failed:", error);
      });
  };

  // 处理稍后提醒
  const handleRemindLater = debounce(() => {
    checkContact({
      pageType: 2,
      actionType: 2, // 用户点击Reminder
    })
      .then((response: ICheckContactResp) => {
        if (response.success) {
          setOpen(false);
        }
      })
      .catch((error) => {
        console.error("Remind later failed:", error);
      });
  }, 500);

  // 处理绑定邮箱
  const handleBindEmail = () => {
    setShowAddEmailModal(true)
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    setShowAddEmailModal(false)
  }

  useEffect(() => {
    setContent(getContent({ status: PAY_STATUS.INIT }));
    initData();
    sendPv.payment_completed();
  }, []);
  return (
    <TransactionStep step={2}>
      {/* <Button onClick={() => setIsOpen(true)}>Open</Button> */}
      <div className={Styles.finishPage}>
        <div className={Styles.finishBox}>
          <div className={Styles.resultBox}>
            <div className={Styles.title}>
              {content.icon}
              {content.title}
            </div>
            {content.tip && <div className={Styles.tips} dangerouslySetInnerHTML={{ __html: payContent || content.tip }}></div>}
            {status === PAY_STATUS.SUCCESS && (
              <div>
                {/* 跳转订单全部 */}
                <Button
                  onClick={() => {
                    sendPayClickTrack.payment_completed_order_details({
                      orderId: (payResultInfo as any).current.orderId,
                    });
                    orderStore.setOrderType("");
                    toPage("list", "click");
                  }}
                  variant="outlined"
                  className={Styles.button}
                >
                  {t("checkout.common.toOrderlist")}
                </Button>
                <Button
                  onClick={() => {
                    sendPayClickTrack.payment_completed_continue_shopping({
                      orderId: (payResultInfo as any).current.orderId,
                    });
                    toPage("index", "click");
                  }}
                  variant="contained"
                  className={Styles.button}
                >
                  {t("checkout.paymentDetail.continueShopping")}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>

      <Recommend
        sceneCode="pay_success_page"
        trackParams={{
          RecomSku_Expo: EXPOSURE_RECORD.Payment_RecomSku_Expo,
          RecomSku_Tab_Expo: EXPOSURE_RECORD.payment_RecomSku_Tab_Expo,
          RecomSku_Addcart_Expo: EXPOSURE_RECORD.payment_RecomSku_Addcart_Expo,
          productClick: sendClickTrack.payment_RecomSku,
          tabClick: sendClickTrack.payment_RecomSku_Tab,
          addCartClick: sendClickTrack.payment_RecomSku_Addcart,
        }}
      />
      {/* 邮箱绑定弹框 */}
      <EmailBindModal open={open} onClose={handleClose} onCloseParent={handleClose}  onBindEmail={handleBindEmail} onRemindLater={handleRemindLater} tipData={tipData} />
      <AddEmailModal 
        isOpen={showAddEmailModal}
        closeHandler={ ()=> setShowAddEmailModal(false)}
      />
    </TransactionStep>
  );
});

export default PayFinish;
